import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_DATASOURCE, Model_VariableEnvironnement, Model_Datasource } from 'src/app/app.models';
import { COMPONENT_MODE } from '../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../workflow-components.service';
  
export class ExpressionBuilderOptions {
	datasource: { ID: any, TEXT: string }[];
    COMPONENTS: Model_WorkflowComponent[];
    VARIABLES_ENVIRONNEMENT: Model_VariableEnvironnement[];
    DATASOURCES: Model_Datasource[];
}

export interface ExpressionBuilderModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
	datasource: { ID: any, TEXT: string }[];
    components: Model_WorkflowComponent[];
    variablesEnvironment: Model_VariableEnvironnement[];
    datasources: Model_Datasource[];
}
  
export class ExpressionBuilderModel extends DynamicInputModel {
	@serializable() readonly type: string = 'expression_builder';
	componentMode: COMPONENT_MODE;
	datasource: { ID: any, TEXT: string }[];
    components: Model_WorkflowComponent[];
    variablesEnvironment: Model_VariableEnvironnement[];
    datasources: Model_Datasource[];
	constructor(config: ExpressionBuilderModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
        this.datasource = config.datasource;
        this.variablesEnvironment = config.variablesEnvironment;
        this.datasources = config.datasources;
		this.components = config.components || [];
	}

	static initModel(_component: Model_WorkflowComponent, _options: ExpressionBuilderOptions): ExpressionBuilderModel {
		const formModel = new ExpressionBuilderModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
            datasource: _options.datasource,
            components: _options.COMPONENTS,
            variablesEnvironment: _options.VARIABLES_ENVIRONNEMENT,
            datasources: _options.DATASOURCES,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
			additional: _component,
			relations: _component.RELATIONS
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
		return {
			ID: 'expression_builder',
			CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX,
			ICON: 'create-outline',
			LABEL: 'ExpressionBuilder',
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
				{ ID: 'INPUT_TYPE', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Type', DEFAULT_VALUE: 'text', IS_REQUIRED: true, 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [{ ID: 'text', TEXT: 'Texte' }, { ID: 'date', TEXT: 'Date' }],
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					}
				},
				{ ID: 'IS_VISIBLE', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Visible ?', DEFAULT_VALUE: true },
				{ ID: 'IS_REQUIRED', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Requis ?' },
			]
		};
	}
}
  